import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Tabs from '../../../components/individualPortal/dashboard/Tabs/Tabs';
import { configs } from '../../../constants/configs/configs';
import WarningMessages from '../../../components/individualPortal/dashboard/AlertMsgs/AlertMessages';
import FurtherActionContainer from './FurtherActionContainer';
import AppStatusContainer from './AppStatusContainer';
import EnrollmentContainer from './EnrollmentContainer';
import MultiHouseholdDetails from '../multiHouseholdDetails';
import { fetchDashboardModels } from '../../../actions/individualPortal/dashboard/dashboardActionCreators';
import { checkVerificationPending } from '../../../actions/common/actionCreators';
import HouseholdEligibilityContainer from './HouseholdEligibilityContainer';
import { ENROLLMENT_TYPES } from '../../../constants/individualPortal/dashboard/dashboardModelTypes';
import { ALL_USER_ROLES } from '../../../constants/roles/userRoleTypes';

// hooks
import useEnv from '../../../hooks/useEnv';
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import SupplementalCoverage from './SupplementalCoverage';

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
    'pageCategory': 'Dashboard',
});

const DashboardContainer = (props) => {

    const { isReady, getEnv } = useEnv();

    const {
        dashboardModels,
        activeTab,
        checkVerificationPending,
        fetchDashboardModels,
        environment: {
            delayPopup,
            isState,
            exchangeName,
            user: {
                role
            },
            flags: {
                isQleMultipleDocumentSupport,
                showSupplementalbenefits,
            },
            links: {
                SUPPLEMENTAL_BENEFITS_LINK,
            }
        },
    } = props;

    const { endpoints } = configs;
    const activeTabData = dashboardModels[activeTab];
    const showFurtherActionSection = !((isState.ID || isState.NV || isState.PA) &&
        (role === ALL_USER_ROLES.APPROVEDADMINSTAFFL1 || role === ALL_USER_ROLES.APPROVEDADMINSTAFFL2));
    sessionStorage.setItem('isQleMultipleDocumentSupport', isQleMultipleDocumentSupport);
    const { setItem, getItem } = useLocalStorage();
    useEffect(() => {
        getEnv();
    }, []);

    useEffect(() => {
        if (isReady) {
            const onVerificationPendingFinishedCb = () => {

                fetchDashboardModels(endpoints.DASHBOARD_MODELS, setItem, getItem);
            };

            if (delayPopup) {
                checkVerificationPending(onVerificationPendingFinishedCb);
            } else {
                onVerificationPendingFinishedCb();
            }
        }
    }, [isReady]);

    useEffect(() => {
        if (dashboardModels && dashboardModels.length > 0 && activeTabData) {
            const { sepEndDate, ssapApplicationId, caseNumber, encryptedCaseNumber, applicationYear } = activeTabData;
            // We need this for old legacy jsp pages to reset data once activeTab is changed.
            sepEndDate && localStorage.setItem('sepEndDate', sepEndDate);
            localStorage.setItem('ssapApplicationId', ssapApplicationId || '');
            localStorage.setItem('enrollCaseNumber', caseNumber);
            localStorage.setItem('encryptedCaseNumber', encryptedCaseNumber);
            localStorage.setItem('applicationYear', applicationYear);
        }
    }, [activeTab]);

    return (dashboardModels && dashboardModels.length > 0 &&
        <div className="dashboard-wrapper">
            <MultiHouseholdDetails />
            <Tabs/>
            {activeTabData &&
                <section role="tabpanel" id={'tabpanel_' + activeTabData.applicationYear}>
                    <WarningMessages/>

                    {showFurtherActionSection &&
                        <FurtherActionContainer/>
                    }

                    <div className="grid-container padding-0">
                        <h3 className=""
                            id={activeTabData.applicationYear + '_dashboard_overview'}>
                            <FormattedMessage id="dashboard.overview"/>
                        </h3>

                        <AppStatusContainer />
                        <hr/>

                        <HouseholdEligibilityContainer />
                        <hr/>

                        <div id="auto-health-plans" className="gi-panel">
                            <EnrollmentContainer enrollmentType={ENROLLMENT_TYPES.HEALTH}/>
                        </div>
                        <hr/>

                        <div id="auto-dental-plans" className="gi-panel">
                            <EnrollmentContainer enrollmentType={ENROLLMENT_TYPES.DENTAL}/>
                        </div>

                        {showSupplementalbenefits && <div className='gi-panel'>
                            <SupplementalCoverage link={SUPPLEMENTAL_BENEFITS_LINK} exchangeName={exchangeName} />
                        </div>}
                    </div>
                </section>
            }

        </div>);
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    dashboardModels: state.individualPortal.dashboard.dashboardModels,
    activeTab: state.individualPortal.dashboard.activeTab,
});

export default connect(mapStateToProps, { checkVerificationPending, fetchDashboardModels })(DashboardContainer);
